export default __webpack_public_path__ + "static/media/csvIcon.df89128a.svg";